import React from 'react';

const HwcTouChengPanel = () => {
  return <div>HwcTouChengPanel</div>;
};

export default HwcTouChengPanel;
